import { Component } from '@angular/core';

@Component({
  selector: 'enrich-page-empty',
  template: '',
})
export class EmptyComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/empty.component.ts